/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Collapse } from "../../core";
import { useFieldListItemContext } from "../../../contexts";

import "./FieldListItemContent.scss";

export interface IFieldListItemContentProps {
	children?: React.ReactNode;
	className?: string;
}

export const FieldListItemContent: React.FC<IFieldListItemContentProps> = ({ children, className }) => {
	const fieldListItemContext = useFieldListItemContext();

	const baseClass = BEM("edt-field-list-item-content", null, {
		expanded: fieldListItemContext?.expanded
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<Collapse className={baseClass.toClassName()} open={fieldListItemContext?.expanded} unmountOnExit>
			<div className={baseClass.toClassName()}>{children}</div>
		</Collapse>
	);
};
